module.exports = __webpack_public_path__ + "static/media/upload.fd39fc65.svg";